import { createAsyncThunk } from '@reduxjs/toolkit';
import { resetCachedCandidates } from '@/store/circleCandidates';

const getAllOutreach = async ({ filters, sort }, { extra: { http } }) => {
  try {
    const { element, order } = sort;
    const { status, user } = filters;

    const params = {
      filter_by: {},
      sort_by: {},
    };

    if (status) {
      params['filter_by']['statuses'] = [status];
    }

    if (user?.id === 'all') {
      params['filter_by']['users'] = 'all';
    } else if (user?.id) {
      params['filter_by']['users'] = [user?.id];
    }

    if (element && order) {
      params['sort_by'][element] = order;
    }

    const result = await http.get('/outreaches', {
      params,
    });
    return result;
  } catch (e) {}
};

const getAllOutreachList = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/outreaches/list');
    return result;
  } catch {}
};

const getAllAddableOutreachesList = async (payload, { extra: { http } }) => {
  try {
    const result = await http.get(
      `/contacts/${payload.contactId}/addable_outreaches`
    );
    return result;
  } catch {}
};

const getAllOutreachListAll = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/outreaches/list/all');
    return result;
  } catch {}
};

// This API will get all the flows that the current user is/was a step sender.
const getAllOutreachUserStepSender = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/outreaches/list/task_user');
    return result;
  } catch {}
};

const onAddCandidatesToOutreach = async (
  { outreachId, contacts = [], multiple = false },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.put(`/outreaches/${outreachId}/add_candidate`, {
      contacts: contacts,
    });

    // Note - This reset the data in store to switch Add to outreach button to Go to outreach
    dispatch(resetCachedCandidates({}));
    return result;
  } catch (e) {}
};

export const fetchAllOutreachesList = createAsyncThunk(
  'outreaches/fetch/list',
  getAllOutreachList
);

export const fetchAllAddableOutreachesList = createAsyncThunk(
  'outreaches/fetch/addableList',
  getAllAddableOutreachesList
);

export const fetchAllOutreaches = createAsyncThunk(
  'outreaches/fetch/all',
  getAllOutreach
);

export const fetchAllOutreachesAll = createAsyncThunk(
  'outreaches/fetch/fulllist',
  getAllOutreachListAll
);

export const fetchAllOutreachesUserSender = createAsyncThunk(
  'outreaches/fetch/task_user',
  getAllOutreachUserStepSender
);

export const addCandidatesToOutreach = createAsyncThunk(
  'outreaches/candidates/add',
  onAddCandidatesToOutreach
);
